import { Typography, Grid, Button, Box, Step, StepLabel, StepContent, Stepper } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

interface IFormStep {
  id: number;
  label: string;
  stepContent: JSX.Element;
}

export type FormStepperProps = {
  formSteps: IFormStep[];
  submitButtonLabel: string;
};

export const FormStepper = (props: FormStepperProps) => {
  const { formSteps, submitButtonLabel } = props;
  const {
    formState: { errors },
    trigger,
  } = useFormContext();

  const { t } = useTranslation(['common']);
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = async () => {
    await trigger();
    if (Object.keys(errors).length === 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = async () => {
    await trigger();
    if (Object.keys(errors).length === 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  // const handleReset = () => {
  //   setActiveStep(0);
  // };

  return (
    <Stepper activeStep={activeStep} orientation='vertical' sx={{ p: 1 }}>
      {formSteps.map((step) => {
        return (
          <Step key={step.id.toString()}>
            <StepLabel>
              <Typography variant='h6'>{step.label}</Typography>
            </StepLabel>
            <StepContent>
              <Box
                sx={{
                  m: 2,
                  xs: {
                    m: 0,
                  },
                }}
              >
                <GridWrapper gutterBottom>
                  {step.stepContent}
                  <Grid item xs={12}>
                    <Button disabled={activeStep === 0} onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
                      {t('button.back')}
                    </Button>
                    <Button variant='contained' color='primary' onClick={handleNext} sx={{ mt: 1, mr: 1 }}>
                      {activeStep === formSteps.length - 1 ? submitButtonLabel : t('button.next')}
                    </Button>
                  </Grid>
                </GridWrapper>
              </Box>
            </StepContent>
          </Step>
        );
      })}
    </Stepper>
  );
};

export default FormStepper;
